module.exports = __webpack_public_path__ + "img/DE00464.9b33a937.png";